import React from 'react';
import { fs } from '../../styles/footerStyles';
import rewardsIso from '../../assets/Rewards_ISO.png';

const Footer = () => {
  const openLink = (url) => window.open(url, '_blank');

  const handleMapClick = () => {
    const address = "Torre Pacífico, Av. Sánchez Bustamante 16, La Paz, Bolivia";
    openLink(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`);
  };

  const sections = [
    { name: 'Últimas Novedades', id: 'news' },
    { name: 'Cronograma Económico', id: 'calendar' },
    { name: 'Operativas y Tutoriales', id: 'tutorials' },
    { name: 'Soporte y Contacto', id: 'support' }
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 115, behavior: 'smooth' });
  };

  return (
    <footer className={fs.footer}>
      <div className={fs.mainWrapper}>
        <div className={fs.logoSection}>
          <img src={rewardsIso} alt="ISO" className={fs.logoImg} />
        </div>

        <div className={fs.columnsContainer}>
          <div className={fs.colStack}>
            <h4 className={fs.colTitle}>Contacto</h4>
            <ul className={fs.list}>
              <li>+591-2 212 6252</li>
              <li><button onClick={() => openLink('mailto:afiliaciones@mscrewards.com')} className={fs.link}>afiliaciones@mscrewards.com</button></li>
              <li className="max-w-[220px]">
                <button onClick={handleMapClick} className={fs.link}>La Paz, Av. Sanchez Bustamante esq. 16 de Calacoto, Torre Pacífico - Piso 4</button>
              </li>
            </ul>
          </div>

          <div className={fs.colStack}>
            <h4 className={fs.colTitle}>Secciones</h4>
            <ul className={fs.list}>
              {sections.map((sec) => (
                <li key={sec.id} onClick={() => scrollToSection(sec.id)} className={fs.link}>{sec.name}</li>
              ))}
            </ul>
          </div>
        </div> 
      </div>

      <div className={fs.bottomBar}>
        <p className={fs.copyright}>© MSC Rewards - SOGEMSA S.A. 2026. Todos los derechos reservados.</p>
      
      </div>
    </footer>
  );
};

export default Footer;